import { insertar } from '../components/servicios/mensajesService.js'
import * as notificacionesService from '../components/servicios/notificacionesService.js'
import * as publicacionesService from '../components/servicios/publicacionesService.js'
import * as tiendasOficialesService from '../components/servicios/tiendasOficialesService.js'
import {
  MENSAJE_TIPO_PUBLICACION_VENCIDA,
  MENSAJE_TIPO_TIENDA_OFICIAL
} from '../constants/mensajesTipos.js'
import {
  ESTADO_PUBLICADA,
  ESTADO_VENCIDA as PUBLICACION_ESTADO_VENCIDA
} from '../constants/publicaciones.js'

import { ESTADO_VENCIDA as TIENDA_ESTADO_VENCIDA } from '../constants/tiendaOficial.js'
import { fechaVenceEnDias, validarRangoFechas } from './dateValidation.js'
import { toastErrorLog } from './toastErrorLog.js'

const CINCO_DIAS = 5

export const publicacionesVencidas = async (data, idUsuario) => {
  try {
    const vencidas = data.filter((p) => {
      if (!p.hasta) {
        return false
      }

      const estaVigente = validarRangoFechas(new Date(), p.hasta, 'day')
      return !estaVigente && p.idPublicacionEstado === ESTADO_PUBLICADA
    })

    if (vencidas.length > 0) {
      await Promise.all(
        vencidas.map((p) =>
          publicacionesService.actualizarEstado(
            p.idPublicacion,
            p.idVendedor,
            PUBLICACION_ESTADO_VENCIDA
          )
        )
      )
      await notificar(
        idUsuario,
        `Tenés publicaciones vencidas que han sido marcadas con estado "Vencida automáticamente". Por favor, revisá las publicaciones para reactivarlas o modificarlas en el menú Ventas -> Administrar.`,
        MENSAJE_TIPO_PUBLICACION_VENCIDA
      )
      return true
    }
    return false
  } catch (error) {
    const mensaje = `Ocurrió un error al verificar publicaciones vencidas.`
    toastErrorLog(error, mensaje, 'venta')
    return false
  }
}

export const tiendaOficialVencimiento = async (tienda, idUsuario, publicaciones) => {
  try {
    const fechaHasta = tienda?.fechaHasta
    if (!fechaHasta) {
      return false
    }

    const { data } = await notificacionesService.buscarPorMensaje(idUsuario)
    const notificaciones = Array.isArray(data?.notificaciones) ? data.notificaciones : []
    const ventanaInicio = new Date(fechaHasta)
    ventanaInicio.setDate(ventanaInicio.getDate() - CINCO_DIAS)
    const yaNotifico = notificaciones.some(
      (n) =>
        n.idMensajeTipo === MENSAJE_TIPO_TIENDA_OFICIAL &&
        validarRangoFechas(ventanaInicio, n.fechaEscrito, 'day')
    )

    if (!validarRangoFechas(new Date(), fechaHasta, 'day')) {
      const idsExcluidos = publicaciones.map((p) => p.idPublicacion)
      await publicacionesService.actualizarExcluidosDeTiendaOficial(tienda.empid, idsExcluidos)
      await tiendasOficialesService.actualizarTienda({
        ...tienda,
        idTiendaOficialEstado: TIENDA_ESTADO_VENCIDA
      })
    } else if (fechaVenceEnDias(fechaHasta, CINCO_DIAS) && !yaNotifico) {
      await notificar(
        idUsuario,
        `Tu tienda oficial "${tienda.nombreTienda}" tiene fecha de vencimiento próxima. Por favor, revisá tu tienda oficial para reactivarla o modificarla en el menú Ventas->Convertir a tienda oficial.`,
        MENSAJE_TIPO_TIENDA_OFICIAL
      )
      return true
    }
    return false
  } catch (error) {
    const mensaje = `Ocurrió un error al verificar el vencimiento de la tienda oficial.`
    toastErrorLog(error, mensaje, 'venta')
    return false
  }
}

const notificar = async (idUsuario, msg, idMensajeTipo) => {
  try {
    const mensaje = {
      idMensajePadre: null,
      idPublicacion: null,
      idPedido: null,
      idPresupuesto: null,
      idVendedor: idUsuario,
      idUsuarioChat: idUsuario,
      idUsuarioEmisor: idUsuario,
      texto: msg,
      privado: true,
      idAdjunto: null,
      idMensajeTipo: idMensajeTipo
    }
    await insertar(mensaje)
  } catch (error) {
    const mensaje = `Ocurrió un error al enviar la notificación.`
    toastErrorLog(error, mensaje, 'venta')
  }
}
